<template>
  <div class="pta-admin pta-callcenter">
    <div class="page-titles border-bottom">
      <h3>Limited Partners // Callcenter</h3>
    </div>
    <div class="container-fluid p-20" style="font-size: 0.75em;">
      <div class="row">
        <div class="col-12">
          <div class="card" v-if="investor_callcenter.total">
            <div class="card-body" style="padding:20px;">
              <div class="table-responsive" v-if="hasPermission('list-user') && investor_callcenter.total">
                <table class="table table-hover" style="margin-bottom:0;" :class="selected_entry?'pta-editmode':''">
                  <thead>
                  <tr>
                    <th scope="col">Name</th>
                    <th scope="col">Job title</th>
                    <th scope="col">Organisation</th>
                    <th scope="col">Phone Work</th>
                    <th scope="col">Phone Org</th>
                    <th scope="col">Campaign</th>
                    <th scope="col" v-if="selected_entry" width="170">Status</th>
                    <th scope="col" v-if="selected_entry" width="224">Result</th>
                    <th scope="col" v-if="selected_entry" width="150">Phone New</th>
                    <th scope="col" v-if="selected_entry" width="424">Notes</th>
                    <th scope="col" class="table-option" width="100" style="width:100px;">{{trans('general.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr :class="selected_entry==investor_callcenter_entry.id?'pta-active':''" style="cursor: pointer" v-for="investor_callcenter_entry in investor_callcenter.data">
                    <td @click="selected_entry==investor_callcenter_entry.id?resetCallcenterEntryForm():setCallcenterEntryForm(investor_callcenter_entry)">
                      {{ investor_callcenter_entry.investor_contact.first_name+' '+investor_callcenter_entry.investor_contact.last_name }}
                    </td>
                    <td @click="selected_entry==investor_callcenter_entry.id?resetCallcenterEntryForm():setCallcenterEntryForm(investor_callcenter_entry)">
                      {{ investor_callcenter_entry.investor_contact.job_title }}
                    </td>
                    <td v-if="investor_callcenter_entry.investor_contact.investor" @click="selected_entry==investor_callcenter_entry.id?resetCallcenterEntryForm():setCallcenterEntryForm(investor_callcenter_entry)">
                      {{ investor_callcenter_entry.investor_contact.investor.name }}
                    </td>
                    <td v-else @click="selected_entry==investor_callcenter_entry.id?resetCallcenterEntryForm():setCallcenterEntryForm(investor_callcenter_entry)">
                      -
                    </td>
                    <td class="pta-phonenumbers">
                      <a :href="'tel:'+phone" v-for="phone in investor_callcenter_entry.investor_contact.phone_work">{{ phone }}</a>
                    </td>
                    <td class="pta-phonenumbers">
                      <a class="pta-phonenumber-org" :href="'tel:'+phone" v-for="phone in investor_callcenter_entry.investor_contact.phone_org">{{ phone }}</a>
                    </td>
                    <td @click="selected_entry==investor_callcenter_entry.id?resetCallcenterEntryForm():setCallcenterEntryForm(investor_callcenter_entry)">
                      {{ investor_callcenter_entry.campaign }}
                    </td>
                    <td v-if="selected_entry">
                      <select class="form-control" v-model="callcenterEntryForm.status" v-if="selected_entry==investor_callcenter_entry.id">
                        <option value="">None</option>
                        <option value="1">Spoken</option>
                        <option value="2">Not Reached</option>
                        <option value="3">Left Voicemail</option>
                        <option value="4">Invalid Number</option>
                        <option value="5">Requested Call back</option>
                        <option value="6">Blocker</option>
                      </select>
                    </td>
                    <td v-if="selected_entry">
                      <select style="width:200px;" class="form-control" v-model="callcenterEntryForm.result" v-if="selected_entry==investor_callcenter_entry.id&&callcenterEntryForm.status==1">
                        <option value="">None</option>
                        <option value="1">Interested, Added to Deal Section and Dates Provided</option>
                        <option value="2">Interested, More Information Requested and Added to Deals Section</option>
                        <option value="3">Not Interested</option>
                        <option value="4">Do not again</option>
                        <option value="5">Not Investing in the Next 12 Months</option>
                        <option value="6">Investing in the Next 12 Months</option>
                      </select>
                      <select style="width:200px;margin-top:5px;" class="form-control" v-model="callcenterEntryForm.client_id" v-if="callcenterEntryForm.result==1 || callcenterEntryForm.result==2">
                        <option value="0" v-if="!callcenterEntryForm.client_id">Please choose campaign</option>
                        <option :value="client.id" v-for="client in clients.data">{{ client.profile.company }}</option>
                      </select>
                    </td>
                    <td v-if="selected_entry">
                      <input class="form-control" type="text" value="" v-model="callcenterEntryForm.phone_new" name="phone_new" v-if="selected_entry==investor_callcenter_entry.id" />
                    </td>
                    <td v-if="selected_entry">
                      <textarea style="width:400px;" class="form-control" v-model="callcenterEntryForm.notes" v-if="selected_entry==investor_callcenter_entry.id"></textarea>
                    </td>
                    <td class="table-option">
                      <div class="btn-group">
                        <button v-if="selected_entry!=investor_callcenter_entry.id" class="btn btn-info btn-sm" v-tooltip="trans('investor_callcenter.edit_entry')" @click="setCallcenterEntryForm(investor_callcenter_entry)"><i class="fas fa-edit"></i></button>
                        <button v-if="selected_entry==investor_callcenter_entry.id" class="btn btn-info btn-sm" v-tooltip="trans('investor_callcenter.cancel')" @click="resetCallcenterEntryForm()"><i class="fas fa-cancel"></i></button>
                        <button v-if="selected_entry==investor_callcenter_entry.id" class="btn btn-info btn-sm" v-tooltip="trans('investor_callcenter.save_entry')" @click="submit()"><i class="fas fa-save"></i></button>
                      <!--  <button class="btn btn-warning btn-sm" v-tooltip="trans('investor_callcenter.mails')"><i class="fas fa-envelope"></i></button> -->
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div v-else>No entries available.</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import userSidebar from "./investor-sidebar";

export default {
  components : { userSidebar },
  data() {
    return {
      selected_entry:0,
      clients: {
        total: 0,
        data: []
      },
      callcenterEntryForm: new Form({
        status: '',
        result: '',
        notes: '',
        phone_new: '',
        client_id: 0,
        client_user_id: 0
      },true),
      investor_callcenter: {
        total: 0,
        data: []
      },
      filterClientForm: {
        name: '',
        contact_person: '',
        sort_by : 'name',
        order: 'asc',
        page_length: 1000
      },
    };
  },
  mounted(){
    if(!helper.hasPermission('edit-user')){
      helper.notAccessibleMsg();
      this.$router.push('/home');
    }
    this.getInvestorCallcenter();
    this.getClients();
  },
  methods: {
    resetCallcenterEntryForm(){
      this.selected_entry = 0;
      this.callcenterEntryForm.status = '';
      this.callcenterEntryForm.result = '';
      this.callcenterEntryForm.notes = '';
      this.callcenterEntryForm.phone_new = '';
      this.callcenterEntryForm.client_id = 0;
      this.callcenterEntryForm.client_user_id = 0;
    },
    setCallcenterEntryForm(investor_callcenter_entry){
      this.selected_entry = investor_callcenter_entry.id;
      this.callcenterEntryForm.client_user_id = investor_callcenter_entry.investor_contact.id;
      this.callcenterEntryForm.client_id = investor_callcenter_entry.campaign_id
    },
    getInvestorCallcenter(){
      axios.get('/api/investor-callcenter')
          .then(response => response.data)
          .then(response => {
            this.investor_callcenter = response;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
    submit(){
      this.callcenterEntryForm.patch('/api/investor-callcenter/'+this.selected_entry)
          .then(response => {
            toastr.success(response.message);
            this.resetCallcenterEntryForm();
            this.getInvestorCallcenter();
          })
          .catch(error => {
            helper.showErrorMsg(error);
          });
    },
    hasPermission(permission){
      return helper.hasPermission(permission);
    },
    getClients(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      let url = helper.getFilterURL(this.filterClientForm);
      axios.get('/api/user/deals?show=all&page=' + page + url)
          .then(response => response.data)
          .then(response => {
            this.clients = response;
          })
          .catch(error => {
            helper.showDataErrorMsg(error)
          });
    },
  },
  filters: {
    moment(date) {
      return helper.formatDateTime(date);
    }
  }
}
</script>
<style>
  .pta-callcenter{
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
  .pta-callcenter th,
  .pta-callcenter td{
    font-size:14px;
    line-heioght:20px;
  }
  .pta-phonenumbers a{
    display:inline-block;
    font-size:12px;
    padding:2px 10px 2px 20px;
    border-radius:5px;
    background:#cccccc url(/images/icon_person_darkblue.svg) no-repeat left 5px center;
    background-size: 12px auto;
    margin-right:10px;
    margin-bottom:10px;
  }
  .pta-phonenumbers a.pta-phonenumber-org{
    background:#dddddd url(/images/icon_company_darkblue.svg) no-repeat left 6px center;
    background-size: 10px auto;
  }
  .pta-editmode tbody tr{
    opacity:0.2;
  }
  .pta-editmode tbody tr.pta-active{
    opacity:1;
  }
</style>
